<template>
  <v-container class="py-2">
    <v-form
      ref="form"
      lazy-validation
    >
      <!--v-model="`valid${g_seg.id}`"-->
      <v-simple-table class="text-center" dense> 
        <template v-slot:default>
          <thead>
            <tr>
              <th>Segmento</th>
              <th 
                v-for="col in columns_pob"
                :width="col.width" 
                class="pa-0 text-center"
                v-if="!col.is_text || g_seg.grupo_segmento.tipo.clave =='PLN'"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <b v-on="on" class="px-3">{{col.header}}</b>
                  </template>
                  <span>{{col.tooltip}}</span>
                </v-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="total_row" v-if="g_seg.grupo_segmento.tipo.total_is_manual">
              <td class="text-left subtitle-1">
                <b> Total {{g_seg.grupo_segmento.nombre}} </b> 
              </td>
              <td 
                v-for="col in columns_pob.filter(d=>!d.is_text)" 
                class="pt-1 pb-0 px-2">
                <v-text-field
                  v-if="col.number"
                  name="total"
                  class="mt-0 pt-0 right-input"
                  type="number"
                  @input="setSaveFill(g_seg)"
                  :readonly="!is_ies || !editable"
                  v-model="g_seg[col.value_name]"
                ></v-text-field>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      v-on="on"
                      @change="setSaveFill(g_seg)"
                      :disabled="col.value_name == 'sin_informacion' || !is_ies || !editable"
                      class="ml-2"
                      v-model="g_seg[col.value_name]"
                    ></v-checkbox>
                  </template>
                  <span>{{col.tooltip}}</span>
                </v-tooltip>
              </td>
              <v-divider></v-divider>
            </tr>
            <tr v-for="pob in g_seg.poblations">
              <td class="text-left">
                <b> {{ pob.segmento.nombre }}</b> 
                <span class="grey--text"> {{pob.segmento.descripcion}}</span>
              </td>
              <td v-if="g_seg.grupo_segmento.tipo.clave =='PLN'">
                <v-text-field
                  dense
                  single-line
                  class="mt-0 pt-0"
                  with="180"
                  @input="setSaveFill(g_seg)"
                  type="text"
                  label="nombre del plan"
                  :readonly="!is_ies || !editable"
                  v-model="pob.nombre_plan"
                  :disabled="disInput(pob) || g_seg.no_aplica"
                ></v-text-field>
              </td>
              <td 
                v-for="col in columns_pob.filter(d=>!d.is_text)"
                class="pt-1 pb-0 px-2"
              >
                <v-text-field
                  v-if="col.number"
                  dense
                  single-line
                  @input="setSaveFill(g_seg)"
                  class="mt-0 pt-0 right-input"
                  :width="col.width"
                  type="number"
                  :readonly="!is_ies || !editable"
                  :id="col.id"
                  v-model="pob[col.value_name]"
                  :disabled="disInput(pob) || g_seg.no_aplica"
                ></v-text-field>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-checkbox
                      v-on="on"
                      @change="setSaveFill(g_seg)"
                      class="ml-2"
                      v-model="pob[col.value_name]"
                      :disabled="disInput(pob, col) || g_seg.no_aplica || !is_ies || !editable"
                    ></v-checkbox>
                  </template>
                  <span>{{col.tooltip}}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <v-card-actions v-if="is_ies && editable">
        <v-spacer></v-spacer>
        <v-btn 
          color="success"
          v-if="g_seg.is_fill"
          class="px-2 mt-3 mb-0"
          @click="saveGrupoSegm()"
        >Guardar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-container>
</template>


<script>

import { mapState } from "vuex";
import router from "@/router.js";

export default {
  name: 'GrupoSegmento',
  props:{
    g_seg:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      columns_pob:[
        {
          "header":"Plan de Estudios",
          "number":true,
          "label":"Plan de estudios",
          "width":180,
          "tooltip":"Nombre del plan de estudios",
          "value_name":"nombre_plan",
          "is_text":true
        },
        {
          "header":"Mujeres",
          "number":true,
          "label":"m",
          "width":80,
          "tooltip":"Número de Mujeres",
          "value_name":"mujeres",
          "is_text":false
        },
        {
          "header":"Hombres",
          "number":true,
          "label":"h",
          "width":80,
          "tooltip":"Número de Hombres",
          "value_name":"hombres",
          "is_text":false
        },
        {
          "header":"N/A",
          "number":false,
          "label":"n/a",
          "width":30,
          "tooltip":"No Aplica",
          "value_name":"no_aplica",
          "is_text":false,
          "opposite":"sin_informacion",
        },
        {
          "header":"S/I",
          "number":false,
          "label":"s/i",
          "width":30,
          "tooltip":"Sin Información",
          "value_name":"sin_informacion",
          "is_text":false,
          "opposite":"no_aplica",
        },
      ],
    }
  },
  methods:{
    saveGrupoSegm(seg_id){
      //console.log(this.g_seg)
      this.$store
        .dispatch('UPDATE_GRUPO_SEGMENTO', {
            data: this.g_seg, 
            grupo_segmento_id: this.g_seg.grupo_segmento.id,
            snack_text: "Se ha guardado la respuesta",
          })
        .then((data) => {
          this.g_seg.is_fill = false
          //console.log(this.g_seg)
        })
        .catch(error =>
          console.log(error)
        );
    },    
    disInput(pob, col){
      if (!!col){
        if (pob[col.opposite])
          return true
      }
      else if (pob.sin_informacion || pob.no_aplica)
        return true
      return false
    },
    setSaveFill(g_seg){
      this.$set(g_seg, 'is_fill', true)
    },    
  },
  computed:{
    ...mapState({
      is_ies: state => state.is_ies,
      editable: state => state.ies_year_data.register_referance.status.can_ies_change,
    }),
  },
}
</script>


<style lang="scss" scoped>

.darks{
  border-color: black !important;
}

.right-input /deep/ input{
  text-align: right;
}

.total_row{
  background-color: #e2e2e2;
}
</style>